import { Injectable } from '@angular/core';
import { CustomerReferenceDto } from 'app/api';

@Injectable({
	providedIn: 'root',
})
export class ReferenceService {
	constructor() {}

	private key = 'reference';

	getCurrentReference(): CustomerReferenceDto {
		// We will need to migrate off of localStorage so this optional path makes sure
		// we don't disrupt users in the middle of a session
		// TODO: create a new PR to remove this
		const storedRef = sessionStorage.getItem(this.key) ?? localStorage.getItem(this.key);
		this.migrateToSessionStorage(storedRef);

		return JSON.parse(storedRef);
	}

	setReference(reference: CustomerReferenceDto): void {
		// TODO: remove in next PR
		localStorage.removeItem(this.key);

		sessionStorage.setItem(
			this.key,
			JSON.stringify({
				source: reference.source.toLowerCase(),
				channel: reference.channel.toLowerCase(),
			})
		);
	}

	clear(): void {
		sessionStorage.removeItem(this.key);
	}

	migrateToSessionStorage(storedRef: string) {
		localStorage.removeItem(this.key);
		sessionStorage.setItem(this.key, storedRef);
	}
}
